import React from "react";

const MentoringSideBarHeader = () => {
  return (
    <div
      className="text-left px-4 pt-4 lsb-wrapper "
      style={{
        height: "175px",
        background:
          "linear-gradient(90deg, rgba(255,255,255,1) 50%, rgba(220,220,220,1) 100%)",
      }}
    >
      <h6 className="mb-0 font-weight-bold" style={{ color: "#07425E" }}>
        IEEE INNOVATION NATION
      </h6>
      <h2 className="font-weight-bold" style={{ color: "#07425E" }}>
        SESSIONS
      </h2>
    </div>
  );
};

export default MentoringSideBarHeader;
